import { IconBugReport, Tooltip } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';

import { ToolbarButton } from './toolbar-button';

const SERVICE_DESK_URL = 'https://newfront.atlassian.net/servicedesk/customer/portal/10/group/39/create/149';

interface ReportBugButtonProps {
  redirectUrl?: string;
}

export function ReportBugButton({ redirectUrl = SERVICE_DESK_URL }: ReportBugButtonProps): JSX.Element {
  return (
    <Tooltip message="Report a Bug" positionTip="bottom" offset="5px">
      <ToolbarButton tabIndex={0} title="Report a Bug" onClick={() => window.open(redirectUrl, '_blank')}>
        <IconBugReport className="dark:text-foreground" />
      </ToolbarButton>
    </Tooltip>
  );
}
